import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { GET_APPLICATION_ID } from "../Forms/genericQueries";
import Button from "./UI/Button";
import SimpleModal from "../SimpleModal/";
import renderStatusModal from "../Forms/renderStatusModal";

const RedirectToForm = (props) => {
  const {
    history,
    newFormType,
    saveFormQuery,
    saveRequest,
    cleanData,
    formDataAccessor,
  } = props;

  const user = useSelector((state) => state.appReducer.userDataReducer.data);

  const [modalState, setModalState] = useState(false);
  const [saveForm, { loading: saveLoading, error: saveError }] =
    useMutation(saveFormQuery);
  const [createNewForm, { loading: createLoading, error: createError }] =
    useMutation(GET_APPLICATION_ID);

  const createNewFormReq = { group_id: user.Group.id, FormType: newFormType };

  return (
    <div>
      <Button onClick={() => setModalState(true)}>
        {`Create ETA-${newFormType} Application`}
      </Button>
      <SimpleModal
        toggleModal={() => setModalState(false)}
        modalStatus={modalState}
        renderButton={() => null}
      >
        <h3>{`Save and Continue to ETA-${newFormType}`}</h3>
        <p className="pwd-description">
          {`Would you like to save this application and redirect to a new ETA-${newFormType} Form?`}
        </p>
        <p>
          You can access this application anytime via the{" "}
          <strong>My Cases</strong> page.
        </p>
        <button
          className={"usa-button usa-button-primary modal-submit"}
          type="button"
          onClick={() => {
            saveRequest[formDataAccessor] = cleanData(
              saveRequest[formDataAccessor]
            );
            saveForm({ variables: saveRequest }).then(() => {
              if (!saveError) {
                createNewForm({ variables: createNewFormReq }).then((res) => {
                  if (!createError) {
                    history.push(
                      `/dashboard/application/${newFormType}/${res.data.addForm}`
                    );
                    renderStatusModal(true, "ETA-9089 case successfully saved");
                  } else {
                    renderStatusModal(false);
                  }
                });
              } else {
                renderStatusModal(false);
              }
            });
          }}
        >
          Save and Continue
        </button>
      </SimpleModal>
    </div>
  );
};

export default withRouter(RedirectToForm);
